import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {DisplayDetailConfig} from "../app-display-detail/app-display-detail.component";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../../../core/shared/dto/object/request/object-request-list";
import {ObjectRequestComplex} from "../../../../../../../core/shared/dto/object/request/object-request-complex";
import {
    ObjectRequestComplexNode
} from "../../../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ObjectRequestRelation} from "../../../../../../../core/shared/dto/object/request/object-request-relation";
import {CustomerDto} from "../../../../../model/dto/entity/customer.dto";
import {CustomerService} from "../../../../../service/api/customer.service";
import {PersonDto} from "../../../../../../pm/model/dto/entity/person.dto";
import {PersonDetailDto} from "../../../../../../pm/model/dto/entity/person-detail.dto";
import {CustomerContactDto} from "../../../../../model/dto/entity/customer-contact.dto";
import {CustomerAddressDto} from "../../../../../model/dto/entity/customer-address.dto";
import {CustomerEmergencyContactDto} from "../../../../../model/dto/entity/customer-emergency-contact.dto";
import {CustomerAgentDto} from "../../../../../model/dto/entity/customer-agent.dto";
import {CustomerBankAccountDto} from "../../../../../model/dto/entity/customer-bank-account.dto";
import {CustomerInsurableObjectDto} from "../../../../../model/dto/entity/customer-insurable-object.dto";

@Component({
    selector: 'overview-component',
    templateUrl: 'overview.component.html',
    standalone: false
})
export class OverviewComponent implements OnInit, OnChanges, OnDestroy {

  busy: boolean;  // indicator whether the component is busy
  initialized: boolean; // indicator whether the component was initialized

  @Input() customerId: number;

  customerDto: CustomerDto;

  customerCardConfig: DisplayDetailConfig = {
    columns: 2,
    showLabels: true,
    fields: [
      {
        key: 'customerConsultingTypeDtoName',
        label: 'Beratungstyp',
        type: 'text'
      },
      {
        key: 'alias',
        label: 'Kundennummer',
        type: 'text'
      },
      {
        key: 'startDate',
        label: 'Kunde seit',
        type: 'date'
      },
      {
        key: 'endDate',
        label: 'endDate',
        type: 'date'
      },
      {
        key: 'customerCategoryTypeDtoName',
        label: 'Kategorie',
        type: 'text'
      },
      {
        key: 'customerTypeDtoName',
        label: 'Kundentyp',
        type: 'icon',
        iconField: 'customerTypeDtoImage',
        colorField: 'customerTypeDtoColor',
        backgroundColorField: 'customerTypeDtoColorBackground'
      },
      {
        key: 'salutation',
        label: 'Anrede',
        type: 'text'
      },
      {
        key: 'brokerPoaTypeDtoName',
        label: 'Maklervollmacht',
        type: 'icon',
        iconField: 'brokerPoaTypeDtoImage',
        colorField: 'brokerPoaTypeDtoColor',
        backgroundColorField: 'brokerPoaTypeDtoColorBackground'
      },
      {
        key: 'active',
        label: 'User Active',
        type: 'boolean'
      }
    ]};

  constructor(protected customerService: CustomerService) {
  }

  ngOnInit(): void {
    this.initComponent();

  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.retrieveCustomerDetails();
  }

  retrieveCustomerDetails() {

    const filterCriteria = FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.customerId);
    const objectRequestList = ObjectRequestList.createBasic(false, [filterCriteria], []);
    objectRequestList.objectRequestComplex = ObjectRequestComplex.build(true, false,
      ObjectRequestComplexNode.createSimpleAttributeNode('person').addNodes(
        ObjectRequestComplexNode.createSimpleAttributeNode('personDetail')),
      ObjectRequestComplexNode.createRelationNode("contacts", ObjectRequestRelation.createJoin('cr.CustomerContact#customer')).addNodes(
        ObjectRequestComplexNode.createSimpleAttributeNode('contact')
      ),
      ObjectRequestComplexNode.createRelationNode("address", ObjectRequestRelation.createJoin('cr.CustomerAddress#customer')),
      ObjectRequestComplexNode.createRelationNode("emergencyContact", ObjectRequestRelation.createJoin('cr.CustomerEmergencyContact#customer')),
      ObjectRequestComplexNode.createRelationNode("customerAgent", ObjectRequestRelation.createJoin('cr.CustomerAgent#customer')),
      ObjectRequestComplexNode.createRelationNode("bankAccount", ObjectRequestRelation.createJoin('cr.CustomerBankAccount#customer')),
      ObjectRequestComplexNode.createRelationNode("insurableObjects", ObjectRequestRelation.createJoin('cr.CustomerInsurableObject#customer')));

    this.customerService.list(objectRequestList).subscribe(customer => {
      this.customerDto = customer.entries[0];

      const person: PersonDto = this.customerDto?.personDto;
      const personDetail: PersonDetailDto = person?.personDetailDto;
      const customerContact: CustomerContactDto = this.customerDto?.['contacts'];
      const address: CustomerAddressDto = this.customerDto?.['address'];
      const emergencyContact: CustomerEmergencyContactDto = this.customerDto?.['emergencyContact'];
      const customerAgent: CustomerAgentDto = this.customerDto?.['customerAgent'];
      const bankAccount: CustomerBankAccountDto = this.customerDto?.['bankAccount'];
      const insurableObjects: CustomerInsurableObjectDto = this.customerDto?.['insurableObjects'];

      this.initialized = true;
    });
  }

  /**
   * Process changes within Binding.
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes["id"]) {
      this.refreshComponent();
    }
  }

  /**
   * Destroy component.
   */
  ngOnDestroy(): void {

  }
}
